import { css, html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';

@customElement('nn-loader')
export class Loader extends LitElement {
  static styles = css`
    #wrapper {
      position: relative;
      height: 100%;
    }

    .profile-main-loader {
      width: 45px;
      position: absolute !important;
      left: calc(50% - 25px) !important;
      top: calc(50% - 25px) !important;
      z-index: 9000 !important;
    }

    .profile-main-loader .loader {
      height: 50px;
      margin: 0px auto;
      width: 50px;
      position: relative;
    }
    .profile-main-loader .loader:before {
      content: '';
      display: block;
      padding-top: 100%;
    }

    .circular-loader {
      height: 100%;
      margin: auto;
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
      animation: rotate 2s linear infinite;
      transform-origin: center center;
    }

    .loader-path {
      stroke-dasharray: 150, 200;
      stroke-dashoffset: -10;
      stroke-linecap: round;
      stroke: var(--nn-bleu-hyperlien, #3695ec);
      animation: dash 1.5s ease-in-out infinite;
    }

    @-webkit-keyframes rotate {
      100% {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
      }
    }

    @keyframes rotate {
      100% {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
      }
    }
    @-webkit-keyframes dash {
      0% {
        stroke-dasharray: 1, 200;
        stroke-dashoffset: 0;
      }
      50% {
        stroke-dasharray: 89, 200;
        stroke-dashoffset: -35;
      }
      100% {
        stroke-dasharray: 89, 200;
        stroke-dashoffset: -124;
      }
    }
    @keyframes dash {
      0% {
        stroke-dasharray: 1, 200;
        stroke-dashoffset: 0;
      }
      50% {
        stroke-dasharray: 89, 200;
        stroke-dashoffset: -35;
      }
      100% {
        stroke-dasharray: 89, 200;
        stroke-dashoffset: -124;
      }
    }
    /* WHERE is used this animation ? */
    @-webkit-keyframes color {
      0% {
        stroke: var(--nn-green-50, #70c542);
      }
      40% {
        stroke: var(--nn-green-50, #70c542);
      }
      66% {
        stroke: var(--nn-green-50, #70c542);
      }
      80%,
      90% {
        stroke: var(--nn-green-50, #70c542);
      }
    }
    @keyframes color {
      0% {
        stroke: var(--nn-green-50, #70c542);
      }
      40% {
        stroke: var(--nn-green-50, #70c542);
      }
      66% {
        stroke: var(--nn-green-50, #70c542);
      }
      80%,
      90% {
        stroke: var(--nn-green-50, #70c542);
      }
    }
  `;

  render() {
    return html`
      <div id="wrapper">
        <div class="profile-main-loader">
          <div class="loader">
            <svg class="circular-loader" viewBox="25 25 50 50">
              <circle
                class="loader-path"
                cx="50"
                cy="50"
                r="20"
                fill="none"
                stroke="#70c542"
                stroke-width="3"
              />
            </svg>
          </div>
        </div>
      </div>
    `;
  }
}
